import { BriefcaseIcon } from "@heroicons/react/outline";

import MultiSelect from "@/components/UnifiedRegistry/FilterBar/MultiSelect";
import { useGetWorkspaces } from "@/queries";
import { Workspace } from "@/types/workspaces";

interface WorkspaceFilterProps {
  organizationId?: number;
  selectedWorkspaceIds: number[];
  onChange: (workspaceIds: number[]) => void;
}

const WorkspaceFilter = ({
  organizationId,
  selectedWorkspaceIds,
  onChange,
}: WorkspaceFilterProps) => {
  const { data: workspacesData } = useGetWorkspaces({ organizationId, perPage: 100 });

  const options = (workspacesData?.items ?? []).map((workspace: Workspace) => ({
    value: workspace.id.toString(),
    label: workspace.name,
  }));

  return (
    <MultiSelect
      options={options}
      selectedValues={selectedWorkspaceIds.map(id => id.toString())}
      onValueChange={values => onChange(values.map(Number))}
      placeholder="Workspace"
      triggerIcon={<BriefcaseIcon className="h-4 w-4 text-gray-600" />}
      aria-label={`Filter by workspace${
        selectedWorkspaceIds.length > 0 ? ` (${selectedWorkspaceIds.length} selected)` : ""
      }`}
    />
  );
};

export default WorkspaceFilter;
